import { render, staticRenderFns } from "./BookingReview.vue?vue&type=template&id=70ea63ff&scoped=true"
import script from "./BookingReview.vue?vue&type=script&lang=js"
export * from "./BookingReview.vue?vue&type=script&lang=js"
import style0 from "./BookingReview.vue?vue&type=style&index=0&id=70ea63ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ea63ff",
  null
  
)

export default component.exports